import * as ROUTES from '../constants/routes'

import { Route, Routes } from 'react-router-dom'

import Clusters from '../pages/Clusters/Clusters'
import Error from '../pages/Error/Error'
import Home from '../pages/Home/Home'
import NotFound from '../pages/NotFound/NotFound'
import Plp from '../pages/Plp/Plp'
import React from 'react'
import Test from '../pages/Test/Test'
import { UserControl } from '../components/UserControl'

export const AppRoutes = {
	login: (): string => '/',
	intro: (): string => '/intro',
	logout: (): string => '/logout',
	create: (): string => '/create',
	edit: (): string => '/edit',
	load: (): string => '/load',
	editStyle: (): string => '/edit/style',
	editCatalog: (): string => '/edit/catalog',
	editProducts: (): string => '/edit/products',
	editConfirmation: (): string => '/edit/confirmation',
	thankYou: (): string => '/edit/thank-you',
	groupList: (): string => '/groups',
	userList: (): string => '/users',
	groupPage: (): string => '/groups/:id',
}

export const CreateRouter: React.FC = () => {
	return (
		<Routes>
			<Route path="/" element={<UserControl />} />
			<Route path={ROUTES.HOME} element={<Home />} />
			<Route path={ROUTES.CLUSTERS} element={<Clusters />} />
			<Route path={ROUTES.PLP} element={<Plp />} />
			{[ROUTES.SESSION_EXPIRED, ROUTES.ACCESS_FORBIDDEN, ROUTES.LOGOUT].map(
				path => (
					<Route key={path} path={path} element={<Error />} />
				),
			)}
			{process.env.REACT_APP_ENVIRONMENT_NAME === 'dev' && (
				<Route path="/test" element={<Test />} />
			)}

			<Route path="*" element={<NotFound />} />
		</Routes>
	)
}
